import axios from '@/utils/axios';
import { messages } from '@/utils';
import * as types from '../mutations-types';

const state = {
    loading: false,
    pedidos: [],
    pageCount: 0
};

const getters = {};

const mutations = {
    [types.LOADING](state, value) {
        state.loading = typeof value !== 'undefined' ? value : true;
    },
    [types.SET_PEDIDOS](state, value) {
        state.pedidos = value;
    },
    [types.SET_PAGE_COUNT](state, value) {
        state.pageCount = value;
    }
};

const actions = {
    async sendPedido({ commit }, { cartItems }) {
        try {
            commit(types.LOADING); // show spinner
            const { data } = await axios.post('/pedidos', {
                cartItems
            });
            return data;
        } catch ({ status, error }) {
            return {
                error: messages.api.error
            };
        } finally {
            commit(types.LOADING, false);
        }
    },

    async getPedidos({ commit }, { page = 1, itemsPerPage = 12 }) {
        try {
            commit(types.LOADING);
            const take = itemsPerPage;
            const { data } = await axios.get('/pedidos', {
                params: {
                    skip: (page - 1) * take,
                    take
                }
            });
            commit(types.SET_PEDIDOS, data.data.pedidos);
            commit(types.SET_PAGE_COUNT, data.data.pageCount);
            return data.data;
        } catch ({ status, error }) {
            return {
                error: messages.api.error
            };
        } finally {
            commit(types.LOADING, false);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
